import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";

import SubPricingOverview from "./SubPricing";
import { PRICINGOVERVIEW } from "npmlinks-constants";

const { OVERVIEW, TEXT, CURRENCY, DISCOUNT_CURRENCY } = PRICINGOVERVIEW;

class PricingOverview extends PureComponent {
  get overviewArray() {
    const { pricingOverviewData = {}, className = "" } = this.props;
    const overviewUnits = [];
    if (pricingOverviewData) {
      Object.entries(pricingOverviewData).forEach(([key, value]) => {
        const curr = [TEXT.discounts, TEXT.loyalty].includes(key) ? DISCOUNT_CURRENCY : CURRENCY;
        if (key) {
          overviewUnits.push(
            <SubPricingOverview.component
              className={`${className} nw-pricing-${key.toLowerCase()}`}
              titleKey={key}
              currency={curr}
              value={value}
              key={key}
            />,
          );
        }
      });
    }
    return overviewUnits;
  }
  render() {
    const { className = "", title } = this.props;
    return (
      <div className="nw-pricingoveriewwrap">
        {(this.overviewArray.length > 0 && (
          <h3 className={`${className} nw-pricing-title`}>{title}</h3>
        )) ||
          null}
        {this.overviewArray}
      </div>
    );
  }
}
PricingOverview.defaultProps = {
  pricingOverviewData: {},
  className: "",
  title: OVERVIEW,
};

PricingOverview.propTypes = {
  pricingOverviewData: PropTypes.shape({}),
  className: PropTypes.string,
  title: PropTypes.string,
};

export { default as SubPricing } from "./SubPricing";

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: PricingOverview,
  component: PricingOverview,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PricingOverview/index.js